import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a point on map with area icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PointOnMapWithAreaIcon width={12} />
 */
const PointOnMapWithAreaIcon = props => (
    <SvgIcon {...props} viewBox="0 0 48 48">
        <path
            d={`M41.87,27.63L35.39,44.33a2,2,0,0,1-1.52,1.22,2,2,0,0,1-.53,0L10.09,43A1.92,
            1.92,0,0,1,8.39,41.4L6,23.73a1.9,1.9,0,0,1,.8-1.81L9.54,20a15.65,15.65,0,0,0,
            1.2,2.25L8.4,23.9,10.65,40.7l22.56,2.45,6.16-15.88-3-3.36a15.74,15.74,0,0,0,
            1.57-2.2l3.59,4A1.87,1.87,0,0,1,41.87,27.63ZM32.5,22.44c-2.14,2.12-8.34,
            6.95-8.34,6.95s-6.2-4.83-8.34-6.95l-0.08-.08a11.67,11.67,0,0,1,.07-16.5,11.85,
            11.85,0,0,1,16.68,0h0l0.07,0.07A11.67,11.67,0,0,1,32.5,22.44Zm-2.09-8.85a6.35,
            6.35,0,1,0-6.35,6.35A6.35,6.35,0,0,0,30.41,13.58Z`}
        />
    </SvgIcon>
)

PointOnMapWithAreaIcon.defaultProps = defaultProps

export { PointOnMapWithAreaIcon }
